export default __webpack_public_path__ + "static/media/logo-new.b49aefe2.png";